import Tooltip from "@src/Components/Tooltip"
import { tState } from "@src/Model/Model"
import { Button } from "@zeguro/component-library"
import * as React from "react"
import { useSelector } from "react-redux"

import {
  CTA,
  DashboardCardHeading,
  FaIconHead,
  FeatureCard,
  HeadingImg,
} from "../styles"
import { EmptyStateCard } from "./EmptyState"
import { FilledStateCard } from "./FilledState"
interface IMonitoringCard {
  isActive: boolean
  gridColumn?: string
  setView: () => void
}

export const TrainingCard: React.FC<IMonitoringCard> = ({
  isActive,
  gridColumn,
  setView,
}) => {
  const trainingData = useSelector(
    (state: tState) => state.portal.dashboard.training,
  )

  const emptyState = !trainingData || trainingData.teamMembers < 1

  return (
    <FeatureCard color="#0062D9" isEmpty={emptyState} gridColumn={gridColumn}>
      <DashboardCardHeading>
        <HeadingImg src="images/icon_training_dash.svg" /> TRAINING
        {!emptyState && (
          <FaIconHead
            className="fas fa-info-circle"
            data-tooltip-id="card-title-training-tooltip"
          />
        )}
      </DashboardCardHeading>
      {emptyState ? (
        <>
          <EmptyStateCard />
          <CTA>
            <Button variant="secondary" width="65%" onClick={setView}>
              {isActive ? "Enroll Team Members" : "Subscribe to Use"}
            </Button>
          </CTA>
        </>
      ) : (
        <>
          <FilledStateCard
            teamMembers={trainingData?.teamMembers}
            isFinished={trainingData?.isFinished}
            isNotFinished={trainingData?.isNotFinished}
            lastUpdated={trainingData?.lastUpdated || new Date()}
          />
          <CTA>
            <Button variant="secondary" width="60%" onClick={setView}>
              {isActive ? "See Team Progress" : "Subscribe to Use"}
            </Button>
          </CTA>
        </>
      )}
      <Tooltip
        id="card-title-training-tooltip"
        type="dark"
        content={
          <>
            <h3>Improve your team’s security awareness.</h3>
            <p>
              Strengthen your first line of defense by providing your team with
              security training. Address each team member’s weakest areas of
              knowledge first.
            </p>
          </>
        }
      />
    </FeatureCard>
  )
}
